<template>
  <div class="aone-amap-container">
    <el-card>
      <div style="padding: 10px 0;display: flex;flex-direction: column;">
        <!-- <span style="font-size: 14px">当前位置:{{ longitude }},{{ latitude }}</span> -->
        <el-button type="primary" size="small" style="float: right" @click="drawerShow = true">选取位置</el-button>
      </div>
      <div style="display: none;" class="aone-amap"></div>
    </el-card>
    <slot></slot>

    <el-drawer title="位置选取" :visible.sync="drawerShow" size="80%" append-to-body>
      <select-box :latitude="latitude" :longitude="longitude" @change="handleChange" @close="handleClose" />
    </el-drawer>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import SelectBox from "./SelectBox.vue";
export default {
  props: ["longitude", "latitude"],
  watch: {
    longitude(val) {
      this.update();
    },
    latitude(val) {
      this.update();
    },
  },
  name: "amap",
  mounted() {
    this.createMap();
  },
  components: {
    SelectBox,
  },
  data() {
    return { drawerShow: false };
  },
  destroyed() {
    this.$amap && this.$amap.destroy();
  },
  methods: {
    handleChange(location, position) {
      this.$emit("change", location, position);
    },
    createMap() {
      let mapEl = this.$el.querySelector(".aone-amap");
      const elementId = uuidv4();
      mapEl.id = elementId;

      this.$amap = new AMap.Map(elementId, {
        labelzIndex: 130,
        pitch: 0,
        expandZoomRange: true,
        zooms: [3, 20],
        resizeEnable: true,
        rotateEnable: true,
        rotateEnable: true,
        zoom: 17,
        showLabel: true,
        showIndoorMap: false,
      });
      this.update();
    },
    update() {
      if (this.longitude && this.latitude) {
        const marker = new AMap.Marker({
          position: new AMap.LngLat(this.longitude || 0, this.latitude || 0),
        });

        // 如果存在进行清除
        if (this.marker) {
          this.$amap.remove(this.marker);
        }

        // 添加marker
        this.$amap.add(marker);
        this.marker = marker;

        this.$amap.setZoomAndCenter(17, [this.longitude || 0, this.latitude || 0]);
      }
    },
    handleClose() {
      this.drawerShow = false;
    },
  },
};
</script>


<style scoped>
.aone-amap-container {
  width: 100%;
}

.aone-amap-container .aone-amap {
  height: 200px;
  border: 1px solid #ccc;
}
</style>
